import ActionSelector from '../../components/ActionSelector'
import { useModuleAction } from '../../hooks/useModuleAction'
import { type TransactionAction } from './constants'
import RemoveTransactionForm from './RemoveTransactionForm'

export default function TransactionModule() {
  const { selectedAction, selectAction, isValidAction } =
    useModuleAction('transaction')

  const formByAction = {
    remove: RemoveTransactionForm,
  } satisfies Record<TransactionAction, React.ComponentType>

  const Form = selectedAction ? formByAction[selectedAction] : null

  if (!isValidAction) {
    return <ActionSelector module='transaction' onSelectAction={selectAction} />
  }

  return <div className='space-y-4'>{Form && <Form />}</div>
}
